module.exports = __webpack_public_path__ + "img/cate_product2.ccc3cb44.png";